export const SMALL_WIDTH = 25;
export const BIG_WIDTH = 40;
export const SMALL_WIDTH_PADDING = 16;
export const BIG_WIDTH_PADDING = 24;
//# sourceMappingURL=constants.js.map